var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    { attrs: { id: "surprise-me-button" }, on: { click: _vm.surpriseMe } },
    [
      _c("div", { staticClass: "d-flex align-items-center gap-10" }, [
        _c("i", { staticClass: "fa fa-magic" }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm._f("trans")("Surprise me")))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }